import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../app/store"
import { importUrsData } from "../documents/import/ursImport"
import { Urs } from "../urs/UrsSlice"

export interface AppDoc {
    blocks: AppBlock[]
    description: string,
    structureId: string
    title: string
    ursNumber: string,
    relatedCompanyName: string
    relatedDocumentId: string
}

export type AppRowType = 'th' | 'tr'

export type AppRow = AppRowGeneric<never>

export interface AppRowGeneric<T> {
    type: AppRowType
    cols: string[]
    plain: string
    split: Split | undefined
    data: T
}

export type AppBlock = AppBlockGeneric<never>

export type AppBlockGeneric<T>
    = { type: 'h'
    , content: string
    , data: T
    , innerText?: string
    }
    | { type: 'p'
    ,  content: string
    , data: T
    , innerText?: string
    }
    | { type: 'table'
    , colsCount: number
    , rows: AppRowGeneric<T>[]
    , innerText?: string
    }
    | { type: 'ul', items: AppLiGeneric<T>[], data: T, innerText?: string }
    | { type: 'ol', items: AppLiGeneric<T>[], data: T, innerText?: string }

export interface AppLiGeneric<T> {
    content: string
    data: T
}

export interface Split {
    index: number
    rowIndex: number
    colIndex: number
    content: string[]
}

export interface ImportedUrsState {
    data: AppDoc | null
    urs: Urs | null
    deleted: number[]
    splits: Split[]
}
const initialState: ImportedUrsState = { data: null, urs: null, deleted: [], splits: [] }

export const importedUrsSlice = createSlice({
    name: 'importedUrs',
    initialState,
    reducers: {
        setImportedDoc: (state, action: PayloadAction<AppDoc>) => {
            state.data = action.payload
        },
        setRelatedUrs: (state, action: PayloadAction<Urs | null>) => {
            state.urs = action.payload
        },
        deleteBlock: (state, action: PayloadAction<number>) => {
            state.deleted.push(action.payload)
        },
        undeleteBlock: (state, action: PayloadAction<number>) => {
            state.deleted = state.deleted.filter(x => x !== action.payload)
        },
        addSplit: (state, action: PayloadAction<Split>) => {
            state.splits.push(action.payload)
        },
        removeSplit: (state, action: PayloadAction<Split>) => {
            state.splits = state.splits.filter(x => x.index !== action.payload.index || x.rowIndex !== action.payload.rowIndex)
        },
    },
    extraReducers: builder => {
        builder.addCase(importUrsData.fulfilled, (state) => {
            state.deleted = []
            state.data = null
            state.urs = null
            state.splits = []
        })
    },
})

export const { setImportedDoc, setRelatedUrs, deleteBlock, undeleteBlock, addSplit, removeSplit } = importedUrsSlice.actions

export const selectImportedUrs = (state: RootState) => state.importedUrs

export default importedUrsSlice.reducer
